import { __extends } from "tslib";
import { Filter3DThresholdTask } from './tasks/Filter3DThresholdTask';
import { Filter3DBase } from './Filter3DBase';
var ThresholdFilter3D = /** @class */ (function (_super) {
    __extends(ThresholdFilter3D, _super);
    /**
     * Creates a new ThresholdFilter3D object
     * @param blurX The amount of horizontal blur to apply
     * @param blurY The amount of vertical blur to apply
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function ThresholdFilter3D() {
        var _this = _super.call(this) || this;
        _this._thresholdTask = new Filter3DThresholdTask();
        _this.addTask(_this._thresholdTask);
        return _this;
    }
    Object.defineProperty(ThresholdFilter3D.prototype, "rect", {
        get: function () {
            return this._thresholdTask.rect;
        },
        set: function (value) {
            this._thresholdTask.rect = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "destPoint", {
        get: function () {
            return this._thresholdTask.destPoint;
        },
        set: function (value) {
            this._thresholdTask.destPoint = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "operation", {
        get: function () {
            return this._thresholdTask.operation;
        },
        set: function (value) {
            this._thresholdTask.operation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "threshold", {
        get: function () {
            return this._thresholdTask.threshold;
        },
        set: function (value) {
            this._thresholdTask.threshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "color", {
        get: function () {
            return this._thresholdTask.color;
        },
        set: function (value) {
            this._thresholdTask.color = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "mask", {
        get: function () {
            return this._thresholdTask.mask;
        },
        set: function (value) {
            this._thresholdTask.mask = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "copySource", {
        get: function () {
            return this._thresholdTask.copySource;
        },
        set: function (value) {
            this._thresholdTask.copySource = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThresholdFilter3D.prototype, "sourceTexture", {
        get: function () {
            return this._thresholdTask.sourceTexture;
        },
        set: function (value) {
            this._thresholdTask.sourceTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    return ThresholdFilter3D;
}(Filter3DBase));
export { ThresholdFilter3D };
